export enum FunctionIsMenuEnum {
    YES = 'Sim',
    NO = 'Não',
}

export type FunctionIsMenu = 'YES' | 'NO';
